function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M12.084 4.25a.473.473 0 01.834 0l8.028 15.059a.47.47 0 01-.417.691H4.473a.47.47 0 01-.417-.691zm.417 1.223L5.258 19.059h14.485L12.5 5.473zM13 16.5v1h-1v-1h1zm0-7v6h-1v-6h1z",
  fill: "#FFB600",
  fillRule: "nonzero"
});

function SvgNotificationAlert(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _ref);
}

export default "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24'%3e %3cg fill='none' fill-rule='evenodd'%3e %3cg fill='%23FFB600' fill-rule='nonzero'%3e %3cg%3e %3cg%3e %3cg%3e %3cpath d='M12.084 4.25c.177-.333.656-.333.834 0l8.028 15.059c.167.313-.061.691-.417.691H4.473c-.356 0-.584-.378-.417-.691zm.417 1.223L5.258 19.059h14.485L12.5 5.473zM13 16.5v1h-1v-1h1zm0-7v6h-1v-6h1z' transform='translate(-799 -549) translate(790 218) translate(0 317) translate(9 14)'/%3e %3c/g%3e %3c/g%3e %3c/g%3e %3c/g%3e %3c/g%3e %3c/svg%3e";
export { SvgNotificationAlert as ReactComponent };